import { createStyles, Theme } from '@material-ui/core'

export const styles = (theme: Theme) =>
  createStyles({
    dataTableWithoutHeader: {
      '& .MuiToolbar-gutters & .': {
        paddingLeft: theme.spacing(0),
        display: 'none'
      }
    },
    description: {
      color: '#828282'
    },
    cardActionsRight: {
      display: 'flex',
      justifyContent: 'flex-end'
    }
  })
